import React, { FC } from 'react';

import UserCard from '../UserCard/UserCard';
import SpaceBetweenBox from '../SpaceBetweenBox/SpaceBetweenBox';
import { Typography } from '../Typography/Typography';

export interface HomeHeaderProps {
  userName?: string;
  showUserType?: boolean;
  handleNavigate: () => void;
}

const HomeHeader: FC<HomeHeaderProps> = ({
  userName,
  showUserType = true,
  handleNavigate,
}) => {
  return (
    <SpaceBetweenBox
      sx={{
        marginBottom: '56px',
      }}
    >
      <Typography variant="h3">Hi {userName?.split(' ')[0]}!</Typography>
      <SpaceBetweenBox>
        <UserCard
          name={userName}
          showUserType={showUserType}
          handleClick={handleNavigate}
        />
      </SpaceBetweenBox>
    </SpaceBetweenBox>
  );
};

export default HomeHeader;
